import type { InternalAxiosRequestConfig } from "axios";

export interface AxiosRequestConfigWithAuth extends InternalAxiosRequestConfig {
	includeAuth?: boolean;
}

export const isAxiosRequestConfigWithAuth = (
	config: InternalAxiosRequestConfig,
): config is AxiosRequestConfigWithAuth => "includeAuth" in config;
